export default __webpack_public_path__ + "u-shaped-thick-magnet.png";